@use '../../../styles/Constants.scss' as Constants;
@use '../../../styles/Colors.scss' as Colors;

$var-resizer-width: 16px;
$var-gap-size: Constants.$val-spacing-m;

@mixin row {
	display: grid;
	align-items: start;
	gap: $var-gap-size;
	padding: 0 Constants.$val-spacing-l;
	border-bottom: 1px solid Colors.$col-design-grey14;
	border-left: 1px solid transparent;
	border-right: 1px solid transparent;

	&:last-child {
		border-bottom: 0;
	}
}

@mixin cell ($type) {
	font-weight: normal;
	display: flex;
	align-items: center;
	height: 100%;
	font-size: Constants.$val-fontSizeSmall;
	line-height: Constants.$val-fontSizeRegular;
	padding: Constants.$val-spacing-s 0;
	min-width: 0;

	@if $type ==header {
		color: Colors.$col-greyInactive;
		font-size: Constants.$val-fontSizeSmall;
		cursor: pointer;
	}

	@if $type ==regular {
		color: Colors.$col-blackDark;
	}

	&:has(div > :global(.show.dropdown)) {
		z-index: 2;
	}

	&:has(:global(.form-group)) {
		& > div {
			margin-bottom: 0px; // form-group has margin-bottom for some reason
		}

		&:has(:global(.help-block)) {
			margin-top: Constants.$val-spacing-m;
			padding: 0;
		}
	}

	&:has(div > :global(.show.dropup)) {
		z-index: 2;
	}
}




.simple-table {
	background-color: Colors.$col-design-grey12;
	overflow-x: auto;

	&__body {
		display: grid;
		background-color: Colors.$col-design-grey12;
		border: 1px solid Colors.$col-design-grey14;
		overflow-x: auto;
	}

	&__title-row {
		border-bottom: none;
		display: flex;
		justify-content: flex-start;

		&__label {
			flex: 1;
			height: Constants.$val-spacing-l;
		}

		&__buttons {
			display: flex;
			gap: Constants.$val-spacing-s;
		}
	}

	&__empty-table-message {
		display: flex;
		color: Colors.$col-greyMid;
		font-style: italic;
		padding: Constants.$val-spacing-xs Constants.$val-spacing-l;
	}

	&__header-row {
		@include row;
	}

	&__row {
		@include row;
		background-color: Colors.$col-design-grey13;
	}

	&__cell {
		@include cell(regular);
	}

	&__header-cell {
		@include cell(header);

		&__name-with-icon {
			flex: 1;
		}
	}

	&__resizer {
		color: Colors.$col-greyInactive;
		cursor: col-resize;
		min-width: $var-resizer-width;
		max-width: $var-resizer-width;
		// placing resizer to the right most part of column cell, due to existence of gap property
		margin-right: (-$var-gap-size);
		height: 100%;
	}

	&__footer-component {
		border: 1px solid Colors.$col-design-grey14;
		border-top: 0;
	}

	&__footer {
		display: flex;
		justify-content: space-between;
		padding: Constants.$val-spacing-xs Constants.$val-spacing-l;
		background-color: Colors.$col-design-grey12;
		border: 1px solid Colors.$col-design-grey14;
		border-top: 0;

	}

	&__footer-buttons {
		display: flex;
		gap: $var-gap-size;
	}

	&__button {
		color: Colors.$col-blue;
		cursor: pointer;

		&:hover {
			color: Colors.$col-darkBlueBorder;
		}

		& > [class^="icon-"] {
			color: Colors.$col-blue;
			margin-right: Constants.$val-spacing-s;

			&:hover {
				color: Colors.$col-darkBlueBorder;
			}
		}
	}

	&__sort-disabled {
		color: Colors.$col-disabled;
		cursor: default;
	}
}

.archived {
	color: Colors.$col-design-grey400 !important;
	background-color: Colors.$col-greyBackgorund2 !important;
	width: 100%;
}